module.exports = __webpack_public_path__ + "img/phones-with-mobile-app.857f570c.png";